/**
 * Zařazení produktu do nákupních seznamů jde i z modalu detailu produktu, který se otevírá
 * nad detailem seznamu. Na rozdíl od změny dat produktu ([[productTileUpdates]]) se tady mění
 * složení seznamu, ne dlaždice — odebrání zvládne detail lokálně, přidání ne (nemá odkud vzít
 * data dlaždice nového produktu), a tak si o ně řekne BE.
 */
export type ShoppingListChange = {
  shoppingListId: number;
  productId: number;
  action: 'added' | 'removed';
};

const SHOPPING_LIST_CHANGED = 'shopping-list-changed';

export const notifyShoppingListChanged = (change: ShoppingListChange) => {
  window.dispatchEvent(new CustomEvent<ShoppingListChange>(SHOPPING_LIST_CHANGED, { detail: change }));
};

export const subscribeShoppingListChanged = (handler: (change: ShoppingListChange) => void) => {
  window.addEventListener(SHOPPING_LIST_CHANGED, event => handler((event as CustomEvent<ShoppingListChange>).detail));
};
